export default "__VITE_ASSET__CL_hJM$F__"